import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'

import FiltersModal from '../../Common/Views/modal/FiltersModal'

import SearchGenre from '../../Genre/Views/SearchGenre'
import SearchSubgenre from '../../Subgenre/Views/SearchSubgenre'
import SearchSerie from '../../Serie/Views/SearchSerie'
import SearchEsrb from '../../Esrb/Views/SearchEsrb'
import SearchPegiAges from '../../Pegi/Views/SearchPegiAges'
import SearchPegiCategories from '../../Pegi/Views/SearchPegiCategories'

export const dateOptions = [
  { key: '1d', value: '1d', text: 'Último día' },
  { key: '1w', value: '1w', text: 'Última semana' },
  { key: '1m', value: '1m', text: 'Último mes' },
  { key: '3m', value: '3m', text: 'Últimos 3 meses' },
  { key: '6m', value: '6m', text: 'Últimos 6 meses' },
  { key: '1y', value: '1y', text: 'Último año' },
  { key: 'all', value: 'all', text: 'Siempre' }
]

export default function GameFiltersModal ({ open, filters, onApply, onCancel, setFilters }) {
  const { t } = useTranslation()

  const handleFilterChange = (e, data) => {
    const { name, value } = data

    setFilters({
      ...filters,
      [name]: value
    })
  }

  return (
    <FiltersModal
      open={open}
      onCancel={onCancel}
      onApply={onApply}
      setFilters={setFilters}
    >
      <Form autoComplete='off'>
        <Form.Dropdown
          fluid
          label={t('generic.createdAt')}
          name='createdAt'
          options={dateOptions}
          placeholder={t('generic.createdAt')}
          selection
          value={filters?.createdAt ?? 'all'}
          onChange={handleFilterChange}
        />
        <Form.Group widths='equal'>
          <SearchGenre
            multiple={false}
            name='genre'
            value={filters?.genre ?? null}
            onChange={handleFilterChange}
          />
          <SearchSubgenre
            multiple={false}
            name='subgenre'
            value={filters?.subgenre ?? null}
            onChange={handleFilterChange}
          />
          <SearchSerie
            name='serie'
            search={false}
            value={filters?.serie ?? null}
            onChange={handleFilterChange}
          />
        </Form.Group>
        <Form.Group widths='equal'>
          <SearchEsrb
            name='esrb'
            search={true}
            value={filters?.esrb ?? null}
            onChange={handleFilterChange}
          />
          <SearchPegiAges
            name='pegiAge'
            value={filters?.pegiAge ?? null}
            onChange={handleFilterChange}
          />
          <SearchPegiCategories
            multiple={false}
            name='pegiCategory'
            value={filters?.pegiCategory ?? null}
            onChange={handleFilterChange}
          />
        </Form.Group>
      </Form>
    </FiltersModal>
  )
}
